import * as React from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllServiceLocations,
  useLoadEntityLocationsOnMount,
} from '@user/store/entityLocations'
import {
  selectAllLeadOppProducts,
  useGetLeadOppProductsOnMount,
} from '@user/store/leadOppProducts'
import {
  selectAllServiceFrequencies,
  useGetServiceFrequenciesOnMount,
} from '@user/store/serviceFrequency'

import { ServicesAddedProps } from './ServicesAddedEdit'

export function useDataExisting(params: ServicesAddedProps) {
  const { entityId, entityType } = params

  const servicesStatus = useGetLeadOppProductsOnMount(entityId, entityType)

  const serviceLocationsStatus = useLoadEntityLocationsOnMount(
    entityId,
    entityType,
  )

  const serviceFreqStatus = useGetServiceFrequenciesOnMount()

  const loading =
    servicesStatus === 'pending' ||
    serviceLocationsStatus === 'pending' ||
    serviceFreqStatus === 'pending'

  const services = useSelector(selectAllLeadOppProducts)
  const serviceLocations = useSelector(selectAllServiceLocations)
  const serviceFrequencies = useSelector(selectAllServiceFrequencies)

  const filteredLocations = React.useMemo(
    () =>
      serviceLocations.filter((l) =>
        services.some((s) => Number(s.serviceLocationId) === l.id),
      ),
    [serviceLocations, services],
  )

  const svcCount = loading ? '' : `(${services.length})`

  const title = `Services Added ${svcCount}`

  return {
    title,
    loading,
    serviceFrequencies,
    serviceLocations: filteredLocations,
  }
}
